import type { ChartConfiguration } from 'chart.js';
import type { HtmCodeGroupId } from '../code-group';
import { HTM_CODE_GROUP_ID_DISPLAY_NAMES } from '../code-group';
import type { HtmCaseCountCollection } from './case-count-data';
import type { HtmDatalabelsChartDataset } from './cost-saving-chart-options';
import {
  COST_SAVINGS_CHART_DATASET_DATALABELS,
  COST_SAVINGS_CHART_OPTIONS,
} from './cost-saving-chart-options';

export class HtmOpportunityCostsClinicCaseCount {
  public data: { nosocomial: { caseCount: number }[] };
  public chart: ChartConfiguration;
  public nosocomialTotal: number;

  protected readonly _codeGroupIds: string[];

  constructor(
    public caseCountByYear: HtmCaseCountCollection,
    public year: number,
  ) {
    this._codeGroupIds = Object.keys(caseCountByYear);

    this._updateCaseCount();
  }

  protected _updateCaseCount() {
    this._setCaseCountData();
    this.chart = this._getChart();
  }

  protected _setCaseCountData() {
    const nosocomial: { caseCount: number }[] = [];

    this._codeGroupIds.map((codeGroupId) => {
      nosocomial.push(
        this.caseCountByYear[codeGroupId as HtmCodeGroupId][this.year] || {
          caseCount: 0,
        },
      );
    });

    this.data = { nosocomial };
    this.nosocomialTotal = nosocomial.reduce((previousValue, currentValue) => {
      if (currentValue.caseCount && !isNaN(currentValue.caseCount)) {
        return previousValue + currentValue.caseCount;
      } else {
        return previousValue;
      }
    }, 0);
  }

  protected _getChart(): ChartConfiguration {
    const nosocomialDataset: HtmDatalabelsChartDataset = {
      data: this.data.nosocomial
        .map((it) => (it ? it.caseCount.toFixed() : '0'))
        .map((it) => parseInt(it, 10)),
      label: 'Nosokominale Infektionen',
      backgroundColor: '#1a5e7e',
      datalabels: COST_SAVINGS_CHART_DATASET_DATALABELS,
    };

    return {
      type: 'bar',
      data: {
        datasets: [nosocomialDataset],
        labels: this._codeGroupIds.map(
          (it) => HTM_CODE_GROUP_ID_DISPLAY_NAMES[it as HtmCodeGroupId],
        ),
      },
      options: {
        ...COST_SAVINGS_CHART_OPTIONS,
        indexAxis: 'y',
      },
    };
  }
}
